<div class="container">
  <div class="all-services">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="all-services__title">All Services</h4>
      <div ngbDropdown class="dropdown">
        <button class="btn btn-link p-0" type="button" ngbDropdownToggle>
          <i class="fas fa-cog text-secondary"></i>
        </button>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
          <div class="dropdown-item" ngbDropdownItem (click)="openManageTabsModal(manageTabsModal)">
            <i class="fas fa-cogs"></i>
            Manage Tab
          </div>
          <div class="dropdown-item" ngbDropdownItem (click)="handleReport()">
            <i class="fas fa-flag mr-1"></i>
            Report
          </div>
        </div>
      </div>
    </div>
    <app-my-carousel-swiper class="my-carousel-width-auto" [config]="carouselOptions">
      <ng-container *ngFor="let item of tabs">
        <div class="swiper-slide" *ngIf="!item.hidden">
          <div class="all-services__tab" [class.active]="row == category" (click)="loadProducts(item.value)"
            [class.active]="selectedTab === item.value">
            <i [class]="item.icon"></i>
            <div class="text">{{ item.name }}</div>
          </div>
        </div>
      </ng-container>
    </app-my-carousel-swiper>

    <div class="tabs" style="position: relative">
      <ng-container *ngIf="showtCarousel as showCarousel">
        <app-my-carousel-swiper *ngIf="showCarousel" [navigation]="false" (onSwiper)="onProductsSwiper($event)"
          (onSlideChange)="onProductSlideChange($event)" class="my-carousel-width-auto" [config]="carouselOptions">
          <ng-container *ngFor="let list of allBottomProducts.data; let i = index">
            <common-product-card-view [list]="list" *ngIf="list.outOfStockAll != 1" (view)="viewProductDetails($event)"
              [postalCode]="locationOfUser" [isCommunityProduct]="true" class="swiper-slide"
              [isUpvote]="true"></common-product-card-view>
          </ng-container>
        </app-my-carousel-swiper>
      </ng-container>
      <ng-container *ngIf="isLoading">
        <common-product-card-view-loader></common-product-card-view-loader>
      </ng-container>
      <div class="my-2">
        <p style="font-size: 2rem; color: black; font-weight: 600; line-height: 1" class="mb-2" *ngIf="promos?.length">
          Promotions</p>

        <app-my-carousel-swiper [navigation]="false" class="my-carousel-width-auto" [config]="promoCarouselOptions">
          <div class="swiper-slide" *ngFor="let promo of promos">
            <app-promo-card [item]="promo"></app-promo-card>
          </div>
        </app-my-carousel-swiper>
      </div>
      <app-votes-section [subRegionName]="userRegionName"
        (viewProduct)="viewProductDetails($event)"></app-votes-section>
      <ng-container *ngIf="selectedTab == 'popular'">
        <app-product-review [categoryName]="'Popular Services'" [subRegionName]="userRegionName"
          (openProd)="viewProductDetails($event)" [productIds]="productIds"></app-product-review>
      </ng-container>
      <!-- <app-manual-review-task [subRegionName]="userRegionName" [userRegionId]="userRegionId"></app-manual-review-task> -->

      <ng-container *ngIf="userRegionId">
        <app-manual-review-task [hideFilter]="true" [subRegionName]="userRegionName" [userRegionId]="userRegionId"
          [title]="'Task Nearby'"></app-manual-review-task>
      </ng-container>
    </div>

    <div class="text-center border-0 p-4" *ngIf="allBottomProducts?.totalCount < 1 && !isLoading">
      <img src="assets/images/no-found-products.png" alt="No Products" class="img-fluid mb-4" />
      <h2 class="card-title fw-bold text-secondary">No Products Found</h2>
      <p class="card-text text-muted">It seems we couldn’t find any products matching your search. Please try adjusting
        your filters or browse our categories.</p>
    </div>
  </div>
</div>


<!-- Modal for managing tabs -->
<ng-template #manageTabsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Manage Category Tabs</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="content">
      <div class="content__title">Show Category Tabs in All Services</div>
      <div class="content__box">
        <ng-container *ngFor="let tab of tabs">
          <div class="sub-cate__item" [ngClass]="{ active: tab.checked }">
            <input [id]="tab?.name" style="opacity: 1; width: 20px" type="checkbox" [(ngModel)]="tab.checked" />
            <label [for]="tab?.name">{{ tab?.name | titlecase }}</label>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveProfileInfo(); modal.close()">Save Changes</button>
  </div>
</ng-template>